module.exports = __webpack_public_path__ + "static/img/arrow_right.f660750.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow_right.png
// module id = icGJ
// module chunks = 1